export default {
    title: {
        new: "Přidat novou adresu",
        complete: "Úplná adresa",
        edit: "Upravit adresu"
    },
    incomplete: "Vyplňte prosím povinná pole adresy",
    info: {
        "CHN": "Zadejte prosím svou adresu v čínštině.</br> Zadejte prosím svou adresu v čínštině.",
        "BGR": "Zadejte svou <b>domácí adresu</b> v angličtině, abyste mohli obdržet své položky.",
        "PRI": "Pro příjem balíků prosím zadejte svou domácí adresu, nikoli P.O. Box.",
        "SGP": "Prosím, uveďte číslo vaší jednotky ve vaší adrese.",
        "SVK": "Zadejte prosím svou adresu v <b>angličtině</b>",
        "POL": "Zadejte prosím svou adresu v <b>angličtině</b>"
    },
    model: {
        country: {
            label: "Země"
        }
    },
    field: {
        default: {
            "name": {
                "label": {
                    "Name": "Jméno"
                },
                "placeholder": {
                    "Name": "Jméno",
                    "Name in English": "Jméno v angličtině"
                }
            },
            personalEmail: {
                label: {
                    "Personal Email": "Osobní e-mail"
                },
                placeholder: {
                    "Personal Email": "Osobní e-mail"
                }
            },
            managerEmail: {
                label: {
                    "Manager Email": "E-mail manažera"
                },
                placeholder: {
                    "Manager Email": "E-mail manažera"
                }
            },
            managerName: {
                label: {"Manager Name": "Jméno manažera"},
                placeholder: {"Manager Name": "Jméno manažera"}
            },
            "postalCode": {
                "label": {
                    "Zipcode": "PSČ",
                    "Post Code": "PSČ",
                    "Postal Code": "Poštovní směrovací číslo",
                    "CPA": "CPA"
                },
                "placeholder": {
                    "Zipcode": "PSČ",
                    "Post Code": "PSČ",
                    "Postal Code": "Poštovní směrovací číslo",
                    "CPA": "CPA"
                }
            },
            "province": {
                "label": {
                    "Province": "Provincie",
                    "Prefecture": "Prefektura",
                    "Province/Region": "Provincie/region",
                    "Province Code": "Kód provincie"
                },
                "placeholder": {
                    "Province": "Provincie",
                    "Prefecture": "Prefektura",
                    "Province/Region": "Provincie/region",
                    "Province Code": "Kód provincie"
                }
            },
            "phoneNumber": {
                "label": {
                    "Phone Number": "Telefonní číslo"
                },
                "placeholder": {
                    "Phone Number": "Telefonní číslo"
                }
            },
            "secondaryPhoneNumber": {
                "label": {"Secondary Phone Number": "Sekundární telefonní číslo"},
                "placeholder": {"Secondary Phone Number": "Sekundární telefonní číslo"}
            },
            "firstStreet": {
                "label": {
                    "Street": "Ulice",
                    "Tax ID": "DIČ"
                },
                "placeholder": {
                    "Street": "Ulice",
                    "Street in English": "Ulice v angličtině",
                    "Tax ID (RUT)": "DIČ (RUT)",
                    "Number/Street/Apartment": "Číslo/Ulice/Byt"
                }
            },
            "secondStreet": {
                "label": {
                    "District": "Okres",
                    "Colonia": "Kolín nad Rýnem",
                    "Canton": "Kanton",
                    "Street": "Ulice"
                },
                "placeholder": {
                    "District": "Okres",
                    "Colonia": "Kolín nad Rýnem",
                    "Canton": "Kanton",
                    "Number/Street/Apartment": "Číslo/Ulice/Byt"
                }
            },
            "city": {
                "label": {
                    "City": "Město",
                    "Town/City/Locality": "Město/Obec/Lokalita",
                    "Town/City": "Město/obec",
                    "City/Municipality/Locality": "Město/Obec/Lokalita",
                    "City/Town/Locality": "Město/Obec/Lokalita",
                    "City/Town": "Město/Obec",
                    "District": "Okres",
                    "City/Town/Locallity": "Město/Obec/Lokalita",
                    "Town/City/Sub Locality": "Město/obec/podokres"
                },
                "placeholder": {
                    "City": "Město",
                    "Town/City": "Město/obec",
                    "Town/City/Locality": "Město/Obec/Lokalita",
                    "City/Municipality/Locality": "Město/Obec/Lokalita",
                    "City/Town/Locality": "Město/Obec/Lokalita",
                    "City/Town in English": "Město/Obec v angličtině",
                    "District": "Okres",
                    "City/Town/Locallity": "Město/Obec/Lokalita",
                    "Town/City/Sub Locality": "Město/obec/podokres"
                }
            },
            identifier: {
                label: {
                    "identifier": "Identifikátor",
                    "Identifier": "Identifikátor"
                },
                placeholder: {
                    "identifier": "Identifikátor",
                    "Identifier": "Identifikátor"
                }
            },
            "region": {
                "label": {
                    "Region": "Kraj",
                    "County": "Hrabství",
                    "Locality": "Lokalita"
                },
                "placeholder": {
                    "Region": "Kraj",
                    "County": "Hrabství",
                    "Locality": "Lokalita"
                }
            },
            "poBox": {
                "label": {
                    "PO BOX": "PO BOX"
                },
                "placeholder": {
                    "PO BOX": "PO BOX"
                }
            },
            state: {
                "label": {
                    "State": "Stát",
                    "Province/Region": "Provincie/region",
                    "Province": "Provincie",
                    "Department": "Oddělení",
                    "Municipality/Comuna": "Obec"
                },
                "placeholder": {
                    "State": "Stát",
                    "Province/Region": "Provincie/region",
                    "Province": "Provincie",
                    "Department": "Oddělení",
                    "Municipality/Comuna": "Obec"
                },
                options: {
                    "Alabama": "Alabama",
                    "Alaska": "Aljaška",
                    "Arizona": "Arizona",
                    "Arkansas": "Arkansas",
                    "California": "Kalifornie",
                    "Colorado": "Colorado",
                    "Connecticut": "Connecticut",
                    "Delaware": "Delaware",
                    "District Of Columbia": "District of Columbia",
                    "Florida": "Florida",
                    "Georgia": "Gruzie",
                    "Hawaii": "Havaj",
                    "Idaho": "Idaho",
                    "Illinois": "Illinois",
                    "Indiana": "Indiana",
                    "Iowa": "Iowa",
                    "Kansas": "Kansas",
                    "Kentucky": "Kentucky",
                    "Louisiana": "Louisiana",
                    "Maine": "Maine",
                    "Maryland": "Maryland",
                    "Massachusetts": "Massachusetts",
                    "Michigan": "Michigan",
                    "Minnesota": "Minnesota",
                    "Mississippi": "Mississippi",
                    "Missouri": "Missouri",
                    "Montana": "Montana",
                    "Nebraska": "Nebraska",
                    "Nevada": "Nevada",
                    "New Hampshire": "Nový Hampshire",
                    "New Jersey": "New Jersey",
                    "New Mexico": "New Mexico",
                    "New York": "New York",
                    "North Carolina": "Severní Karolína",
                    "North Dakota": "Severní Dakota",
                    "Ohio": "Ohio",
                    "Oklahoma": "Oklahoma",
                    "Oregon": "Oregon",
                    "Pennsylvania": "Pensylvánie",
                    "Rhode Island": "Rhode Island",
                    "South Carolina": "Jižní Karolína",
                    "South Dakota": "Jižní Dakota",
                    "Tennessee": "Tennessee",
                    "Texas": "Texas",
                    "Utah": "Utah",
                    "Vermont": "Vermont",
                    "Virginia": "Virginie",
                    "Washington": "Washington",
                    "West Virginia": "Západní Virginie",
                    "Wisconsin": "Wisconsin",
                    "Wyoming": "Wyoming"
                }
            },
            "deliveryInstructions": {
                "label": {
                    "Delivery Instructions": "Pokyny k doručení"
                },
                "placeholder": {
                    "Extra address information, delivery instructions, etc. ": "Doplňující informace o adrese, pokyny k doručení atd. ",
                    "Extra address information, delivery instructions, etc. in English ": "Doplňující informace o adrese, pokyny k doručení atd. v angličtině ",
                    "Extra address information, delivery instructions, etc": "Doplňující informace o adrese, pokyny k doručení atd."
                }
            },
        },
        BRA: {
            name: {
                label: {"Full name": "Celé jméno"},
                placeholder: {"Full name": "Celé jméno"}
            },
            firstStreet: {
                label: {"Address 1": "Adresa 1"},
                placeholder: {"Address 1": "Ulice + číslo domu/bytu"}
            },
            secondStreet: {
                label: {
                    "Address 2": "Adresa 2",
                    "District": "Okres"
                },
                placeholder: {
                    "Address 2": "Ulice + číslo domu/bytu",
                    "District": "Okres"
                }
            },
            city: {
                label: {City: "Město"},
                placeholder: {City: "Město"},
            },
            state: {
                label: {State: "Stát"},
                placeholder: {State: "Stát"}
            },
            "postalCode": {
                "label": {
                    "Zipcode": "PSČ",
                    "Post Code": "PSČ",
                    "Postal Code": "Poštovní směrovací číslo",
                    "CPA": "CPA"
                },
                "placeholder": {
                    "Zipcode": "PSČ",
                    "Post Code": "PSČ",
                    "Postal Code": "Poštovní směrovací číslo",
                    "CPA": "CPA"
                }
            },
            identifier: {
                "label": {
                    "Tax ID": "DIČ"
                },
                "placeholder": {
                    "Tax ID (CDI, CUIT, CUIL, etc)": "DIČ (CDI, CUIT, CUIL atd.)"
                }
            }
        },
        IND: {
            state: {
                label: {"State/Territory": "Stát/Území"},
                options: {
                    "Andaman and Nicobar Islands": "Andamanské a Nikobarské ostrovy",
                    "Arunachal Pradesh": "Arunáčalpradéš",
                    "Assam": "Ásám",
                    "Bihar": "Bihár",
                    "Chandigarh": "Čandígarh",
                    "Chhattisgarh": "Čhattísgarh",
                    "Dadra and Nagar Haveli and Daman and Diu": "Dadra a Nagar Haveli a Daman a Diu",
                    "Delhi": "Dillí",
                    "Goa": "Goa",
                    "Gujarat": "Gudžarát",
                    "Haryana": "Harijána",
                    "Himachal Pradesh": "Himáčalpradéš",
                    "Jammu and Kashmir": "Džammú a Kašmír",
                    "Jharkhand": "Džhárkhand",
                    "Karnataka": "Karnátaka",
                    "Kerala": "Kérala",
                    "Ladakh":"Ladakh",
                    "Lakshadweep": "Lakšadvíp",
                    "Madhya Pradesh": "Madhjapradéš",
                    "Maharashtra": "Maháráštra",
                    "Manipur": "Manipur",
                    "Meghalaya": "Meghálaja",
                    "Mizoram": "Mizoram",
                    "Nagaland": "Nagaland",
                    "Odisha": "Urísa",
                    "Puducherry": "Pudučéri",
                    "Punjab": "Paňdžáb",
                    "Rajasthan": "Rádžasthán",
                    "Sikkim": "Sikkim",
                    "Tamil Nadu": "Tamilnádu",
                    "Telangana":"Telangana",
                    "Tripura": "Tripura",
                    "Uttar Pradesh": "Uttarpradéš",
                    "Uttarakhand": "Uttarákhand",
                    "West Bengal": "Západní Bengálsko",
                    "Andhra Pradesh": "Ándhrapradéš"
                }
            }
        }
    },
    errors: {
        required: "Je vyžadován argument {field}.",
        mask: "{field} je neplatné."
    },
    buttons: {
        submit: {
            text: "Uložit",
            saving: "Ukládání"
        },
        cancel: {
            text: "Zrušit"
        }
    },
    disclaimer: "Přidání této adresy bude vyžadovat ověření e-mailu. Po uložení adresy si prosím zkontrolujte e-mail a klikněte na odkaz v něm.",
    message: {
        added: "Adresa byla přidána",
        updated: "Adresa byla aktualizována"
    }
}